import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { DataTable } from 'primereact/datatable';
import { Row } from 'primereact/row';
import { analyticsApiSlice } from '../../../api/rtk/base/slices/analyticsApiSlice';
import { Loader } from '../../loaders/Loader';
import { getAnalyticsTableBasicBody } from '../../tablesShared/tableTools/tableCellBodies';
import { thousandSeparator, uniqueValues } from '../../../features/dataFormatFunctions/dataFormatter';
import { getItemWebStorage } from '../../../features/webStorageSaver';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { getRandomKey } from '../../../features/randomUuidKey/randomUuidKey';

// Компонент - таблица для отображения отчета
export function AnalyticsReportTable() {
    // определение id типа объекта при его наличии в хранилище
    const {
        GroupID,
        FilterID,
        FilterValues,
        CurrentObjectClassesIds,
        CurrentObjectClassId,
        Position,
        Ending } = getItemWebStorage('analytics') ? getItemWebStorage('analytics') :
            {
                GroupID: null,
                FilterID: null,
                FilterValues: null,
                CurrentObjectClassesIds: null,
                CurrentObjectClassId: null,
                Position: null,
                Ending: null
            }

    const navigate = useNavigate()
    // при отсутствии id типа объекта понимаем, что типов объектов несколько
    let isLoadingMultipleData: any = [], isLoadingData: any = false
    let columns: any = []
    let report: any
    let allValues: any = []
    // получение выбранных значений фильтров для дальнейшей отправки запроса
    let roadOptionsUrl: any
    (Position && Ending) ? roadOptionsUrl = `&Position=${Position}&Ending=${Ending}` : roadOptionsUrl = ''

    // обработка наличия нескольких выбранных типов объектов
    if (CurrentObjectClassesIds) {
        let dataPack: any = []
        // оправка запроса для каждого типа объекта и добавление данных в общий массив
        CurrentObjectClassesIds.map((item: any, index: any) => {
            const {
                data: reportData,
                isLoading: isLoadingMultiple,
                isSuccess: gotMultipleData
            } = analyticsApiSlice.useFetchAnalyticsReportQuery(
                {
                    classId: item,
                    groupId: GroupID,
                    aggregateFilterId: FilterID,
                    aggregateFilterValues: encodeURIComponent(JSON.stringify(FilterValues).substring(1, JSON.stringify(FilterValues).length - 1)),
                    roadOptionsUrl: roadOptionsUrl
                })
            isLoadingMultipleData[index] = gotMultipleData
            gotMultipleData && dataPack.push(reportData)
        })
        let columnsNames: any = []

        // получение списка названий всех требующихся колонок
        dataPack.length === CurrentObjectClassesIds.length && dataPack.map(async (item: any) => {
            item.AggregateReport[0] && Object.keys(item.AggregateReport[0]).map((key: any) => {
                columnsNames.push(key)
            })
        })
        // извлечение уникального списка названий из общего
        let uniqueColumnsNames = columnsNames && columnsNames.filter(uniqueValues)
        // составление требующегося списка колонок
        uniqueColumnsNames.map((item: any) => {
            columns.push({
                headerName: item,
                field: item,
                canBeSorted: true,
            })
        })
        // составление всего объекта данных 
        report = dataPack && dataPack
        report.map((item: any) => {
            item.AggregateReport.map((value: any) => {
                value = { ...value, Description: item.Description }
                allValues.push(value)
            })
        })
    }
    // обработка наличия единственного типа объекта
    else {
        // отправка запроса на получение аналитических данных по конкретному типу объекта
        const {
            data: reportData,
            isLoading: isLoading
        } = analyticsApiSlice.useFetchAnalyticsReportQuery(
            {
                classId: CurrentObjectClassId,
                groupId: GroupID,
                aggregateFilterId: FilterID,
                aggregateFilterValues: encodeURIComponent(JSON.stringify(FilterValues).substring(1, JSON.stringify(FilterValues).length - 1)),
                roadOptionsUrl: roadOptionsUrl
            })
        report = reportData && reportData
        isLoadingData = isLoading;

        // составление требующегося списка колонок
        (report && report.AggregateReport.length > 0) && Object.keys(report.AggregateReport[0]).map((key: any) => {
            columns.push({
                headerName: key,
                field: key,
                canBeSorted: true,
            })
        })
        // составление объекта данных для отчета
        report && report.AggregateReport.map((item: any) => {
            item = { ...item, Description: report.Description }
            allValues.push(item)
        })

    }

    // Шаблон для промежуточных шапок таблицы (с названиями типов объектов)
    function getHeaderTemplate(data: any) {
        return (
            <div className="flex align-items-center gap-2">
                <strong className="font-bold">{data.Description}</strong>
            </div>
        );
    }

    // Шаблон для подвала таблицы
    const footerTemplate = (
        <ColumnGroup  key={getRandomKey()}>
            <Row  key={getRandomKey()}>
                <Column footer="Итого:" colSpan={columns.length} footerStyle={{ textAlign: 'left' }}  key={getRandomKey()}/>
            </Row>
            <Row  key={getRandomKey()}>
                {/* Подсчет суммы значений для числовых колонок с обработкой приписок Макс. , Ср. */}
                {
                    columns.map((col: any) => {
                        let total = 0
                        let max = 0
                        let average = 0
                        let count = 0
                        allValues.map((item: any) => {
                            if (col.field.includes('Макс.')) {
                                if (item[col.field]) {
                                    item[col.field] > max ? max = item[col.field] : max = max
                                }
                            }
                            if (col.field.includes('Ср.')) {
                                if (item[col.field]) {
                                    average += item[col.field]
                                    count++
                                }
                            }
                            if (!col.field.includes('Ср.') && !col.field.includes('Макс.')) {

                            }
                            if (item[col.field] && col.field != 'Количество') {
                                total += item[col.field]
                            }
                            if (item[col.field] && col.field === 'Количество') {
                                total += parseFloat(item[col.field])
                            }
                        })
                        if (typeof total === 'number') {
                            if (col.field.includes('Макс.')) {
                                return <Column footer={thousandSeparator(max?.toFixed(2)?.toString())} footerStyle={{ textAlign: 'right' }} key={getRandomKey()}/>
                            }
                            if (col.field.includes('Ср.')) {
                                return <Column footer={thousandSeparator((average / count)?.toFixed(2)?.toString())} footerStyle={{ textAlign: 'right' }} key={getRandomKey()}/>
                            }
                            if (!col.field.includes('Ср.') && !col.field.includes('Макс.')) {
                                return <Column footer={thousandSeparator(total?.toFixed(2)?.toString())} footerStyle={{ textAlign: 'right' }} key={getRandomKey()}/>
                            }
                        } else {
                            return <Column footer={undefined} key={getRandomKey()}/>
                        }
                    })
                }
            </Row>
        </ColumnGroup>
    );

    return (
        <> {(CurrentObjectClassId || CurrentObjectClassesIds?.length > 0)
            ?
            <div className="analytics-report-div">
                {!isLoadingMultipleData.every(Boolean) || isLoadingData
                    ?
                    <Loader />
                    :
                    (report ?
                        <DataTable
                            value={allValues && allValues}
                            scrollable
                            scrollHeight="calc(100dvh - 164px)"
                            size="small"
                            removableSort
                            selectionMode="single"
                            dataKey="id"
                            paginator={allValues.length > 500}
                            rows={200}
                            rowGroupMode="subheader"
                            groupRowsBy="Description"
                            rowGroupHeaderTemplate={getHeaderTemplate}
                            footerColumnGroup={allValues.length > 1 && footerTemplate}
                            loading={isLoadingData}
                            loadingIcon={<Loader />}
                            emptyMessage="Данных нет" >
                            {/* Столбцы таблицы */}
                            {columns?.map((item: any, idx: any) => (
                                <Column
                                    key={getRandomKey()}
                                    field={item.field}
                                    sortable={item.canBeSorted}
                                    header={item?.imageSrc ? <img src={item?.imageSrc} /> : item.headerName}
                                    body={(rowData) => getAnalyticsTableBasicBody(rowData, item.field)}
                                    align="right"
                                    dataType={(item.valueType === "float" || item.valueType === "int") ? "numeric" : undefined}
                                >
                                </Column>
                            ))}
                        </DataTable>
                        :
                        ''
                    )
                }
            </div>
            :
            <div className="m-5 analytics-report-warning-div">
                <Card title="Не выбран объект" style={{ width: "fit-content" }}>
                    <p className="m-0">
                        <Button className="no-objects-redirect-button" onClick={() => navigate('/app/analytics/selectObjects')} style={{ backgroundColor: "#66AFDF", color: "white", border: "0", fontWeight: "bold" }}>Выбрать</Button>
                    </p>
                </Card>
            </div>
        }
        </>

    );
}

